var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogledrive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 25,
    viewBox: "0 0 28 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_113_81653)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.26661 21.0692L3.45122 23.1154C3.69738 23.5462 4.05122 23.8846 4.46661 24.1308L8.69738 16.8077H0.23584C0.23584 17.2846 0.358917 17.7615 0.605071 18.1923L2.26661 21.0692Z",
    fill: "#0066DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6666 8.19231L9.43584 0.869232C9.02046 1.11539 8.66661 1.45385 8.42046 1.88462L0.605071 15.4231C0.363444 15.8446 0.236162 16.3219 0.23584 16.8077H8.69738L13.6666 8.19231Z",
    fill: "#00AC47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8666 24.1308C23.282 23.8846 23.6359 23.5462 23.882 23.1154L24.3743 22.2692L26.7282 18.1923C26.9743 17.7615 27.0974 17.2846 27.0974 16.8077H18.6353L20.4359 20.3462L22.8666 24.1308Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6666 8.19231L17.8973 0.869231C17.4819 0.623077 17.005 0.5 16.5127 0.5H10.8204C10.3281 0.5 9.85118 0.638462 9.43579 0.869231L13.6666 8.19231Z",
    fill: "#00832D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6358 16.8077H8.69732L4.46655 24.1308C4.88194 24.3769 5.35886 24.5 5.85117 24.5H21.4819C21.9742 24.5 22.4512 24.3615 22.8666 24.1308L18.6358 16.8077Z",
    fill: "#2684FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8204 8.65385L18.9127 1.88462C18.6665 1.45385 18.3127 1.11539 17.8973 0.869232L13.6665 8.19231L18.6357 16.8077H27.0819C27.0819 16.3308 26.9588 15.8538 26.7127 15.4231L22.8204 8.65385Z",
    fill: "#FFBA00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_113_81653"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.8615,
    height: 24,
    fill: "white",
    transform: "translate(0.23584 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogledrive);
export default __webpack_public_path__ + "static/media/googledrive.455b61fe62a5b1b304652ee7ca11305f.svg";
export { ForwardRef as ReactComponent };